export default __webpack_public_path__ + "static/media/france.8a17db68.jpg";